import { t } from "@/i18n-js/instance";
import { useIsPropertiesPanelRevampEnabled } from "@circle-react-shared/BuilderUI/Hooks/useIsPropertiesPanelRevamp";
import { Form } from "@circle-react-uikit/Form";
import { FormCustomHtmlEditor } from "../CustomHTMLEditor/FormCustomHtmlEditor";

export interface CustomHtmlFieldProps {
  label: string;
  name: string;
}

export const CustomHtmlField = ({ name, label }: CustomHtmlFieldProps) => {
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();

  return (
    <Form.Item
      name={name}
      label={label}
      description={t("builder_ui.custom_html.disclaimer_message")}
      hideBorder
      labelClassName="!font-normal text-xs"
      className="!p-0"
    >
      {!isPropertiesPanelV2 && <div className="mt-2" />}
      <FormCustomHtmlEditor name={name} />
    </Form.Item>
  );
};
